// extracted by mini-css-extract-plugin
export default {"field":"UserInformationEdit_field__0SBlB","text":"UserInformationEdit_text__KQgCF"};